import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import jobsService from '../../api/jobsService'

const initialState = {
  jobs: [],
  isLoading: false,
  isError: false,
  isSuccess: false,
  message: '',
}

// Fetch job details by database name
export const fetchJobs = createAsyncThunk(
  'jobs/fetchAll',
  async (databaseName, thunkAPI) => {
    try {
      return await jobsService.getJobs(databaseName)
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString()
      return thunkAPI.rejectWithValue(message)
    }
  }
)

const jobsSlice = createSlice({
  name: 'jobs',
  initialState,
  reducers: {
    reset: (state) => {
      state.isLoading = false
      state.isError = false
      state.isSuccess = false
      state.message = ''
    },
    clearJobs: (state) => {
      state.jobs = []
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobs.pending, (state) => {
        state.isLoading = true
      })
      .addCase(fetchJobs.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.jobs = Array.isArray(action.payload) ? action.payload : []
      })
      .addCase(fetchJobs.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.message = action.payload
      })
  },
})

export const { reset, clearJobs } = jobsSlice.actions
export default jobsSlice.reducer
